<script>
import DidoCatalog from "./components/Catalog.vue";

export default {
  name: "DidoCatalogCe",
  components: {
    DidoCatalog,
  },
  props: {
    didoUrl: { type: String, required: true },
    didoCatalogContactUrl: { type: String, required: false, default: void 0 },
    didoLinkedDocsUrl: { type: String, required: false, default: void 0 },
    didoInitialExploreUrl: { type: String, required: false, default: void 0 },
    didoMessageService: { type: Boolean, required: false, default: false },
    didoMessageServiceType: { type: String, required: false, default: void 0 },
    didoMessageServiceContent: {
      type: String,
      required: false,
      default: void 0,
    },
    didoMessageServicePermanent: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["bad-configuration"],
  template: `
    <DidoCatalog
      :api-url="didoUrl"
      :catalog-contact-url="didoCatalogContactUrl"
      :linked-docs-api-url="didoLinkedDocsUrl"
      :initial-explore-url="didoInitialExploreUrl"
      :message-service="didoMessageService"
      :message-service-type="didoMessageServiceType"
      :message-service-content="didoMessageServiceContent"
      :message-service-permanent="didoMessageServicePermanent"
      @bad-configuration="$emit('bad-configuration')"
    >
      <template #messageServiceContent>
        <slot name="didoMessageServiceContent">{{ didoMessageServiceContent || 'un message de service'}}</slot>
      </template>
    </DidoCatalog>`,
};
</script>
